/**
 * Feature flags for GenZ Credit Score.
 * Toggle these at build/runtime to switch between placeholder/mock
 * and real production integrations.
 */

// DigiLocker: Government Identity integration (Aadhaar, marksheets, etc.)
// When false  -> shows "Coming Soon" modal with Upload / Manual fallbacks
// When true   -> kicks off real DigiLocker OAuth + doc pull
export const FF_DIGILOCKER =
    (process.env.REACT_APP_FF_DIGILOCKER || "false").toLowerCase() === "true";

// iWebTechno ERP: Direct college ERP integration (VJTI, SPIT, etc.)
// When false  -> shows a polished mock (2s loading -> VJTI Mumbai demo data)
// When true   -> calls live iWebTechno ERP endpoints and pulls real data
export const FF_IWEBTECHNO_DIRECT =
    (process.env.REACT_APP_FF_IWEBTECHNO_DIRECT || "false").toLowerCase() === "true";

// Ecom Consumption workflow (Amazon / Flipkart / Zomato / Zepto / Bank AA)
// When true   -> wizard expands from 7 -> 9 steps with consumption signals
export const FF_ECOM_CONSUMPTION =
    (process.env.REACT_APP_FF_ECOM_CONSUMPTION || "false").toLowerCase() === "true";
